import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { CSS, Href, Vendors, Javascript } from "../../../../Constants/Constants";
import { SimpleNavProps } from "../../../../Types/UiKitsType";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";

const BottomTabsNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav pills className="nav-primary" id="pills-bg-tab3">
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>
          <Image src={dynamicImage("tree/html.png")} alt="" />
          {CSS}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>
          <Image src={dynamicImage("tree/vendor.png")} alt="" />
          {Vendors}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>
          <Image src={dynamicImage("tree/js.png")} alt="" />
          {Javascript}
        </NavLink>
      </NavItem>
    </Nav>
  );
};
export default BottomTabsNav;
